import { render, staticRenderFns } from "./NewIncident.vue?vue&type=template&id=60e67ee4&"
import script from "./NewIncident.vue?vue&type=script&lang=js&"
export * from "./NewIncident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports